import { pollFooterCss } from "../Poll/Poll.style";

export const footerCss = (canSeeResults) => ({
  ...pollFooterCss,
  justifyContent: canSeeResults ? "space-between" : "flex-end",
});
